import React from "react";
import Slider from "./Slider/Slider";
import Store from "./Store/Store";

const Home = () => {
  return (
    <div>
      <Slider />
      <Store />
    </div>
  );
};

export default Home;
